import { useState, useEffect, useCallback } from 'react';

// mui
import { Grid } from '@mui/material';

// components
import { FilterAutoComplete } from '../internal.js';

// client-shared
import { str } from '@goldblack/client-utils';

/*
trending
<FilterItem options='searchOptions' filterType filters actions />

search
<FilterItem options='searchOptions' filterType actions />

profile
<FilterItem options='inputOptions' filterType filters filterConsents actions />
*/
function FilterItem(props) {
    const options = props.filterType[props.options] || [];
    const { filterType, filters, filterConsents, actions } = props;
    const [values, setValues] = useState([]);
    const [inputValues, setInputValues] = useState([]);
    const [displays, setDisplays] = useState([]);
    const [consentValue, setConsentValue] = useState(false);
    const [consentInput, setConsentInput] = useState(false);

    useEffect(() => {
        if (filters) {
            // set current values as default in values, inputValues
            let found = filters?.find((f) => f.filterId === filterType._id);
            if (found) {
                setInputValues(JSON.parse(found.inputValue));
                setValues(JSON.parse(found.value));
                setDisplays(JSON.parse(found.display));
            }
        }

        if (filterConsents) {
            setConsentInput(!!(filterConsents && filterConsents[filterType._id]));
        }
    }, []);

    const addOrReplaceInArray = (prev, filterId, newObj) => {
        let index = prev.filters && prev.filters.findIndex((x) => x.id === filterId);
        if (index !== undefined && index !== -1) {
            prev.filters[index] = newObj;
        } else {
            if (!prev.filters) {
                prev.filters = [];
            }
            prev.filters.push(newObj);
        }
        return prev;
    };

    const onChangeValue = useCallback(
        (index, option, newValue) => {
            const nextInputValues = inputValues.slice();
            const nextValues = values.slice();
            const nextDisplays = displays.slice();

            if (newValue && newValue.length > 0) {
                // array of array - [0:['English'], 1:['Korean'], 2:['Japanese']]
                if (Array.isArray(newValue[0])) {
                    nextDisplays[index] = newValue.map((x) => str.formatStringArray(option.resultDisplay, x));
                    nextValues[index] = newValue.map((x) =>
                        str.formatTrimmed(str.formatStringArray(option.resultDisplay, x)),
                    );
                    nextInputValues[index] = newValue;
                }
                // array - [0:'A Coruna', 1:'Spain', 2:'43.3667', 3:'-8.3833']
                else {
                    nextDisplays[index] = str.formatStringArray(option.resultDisplay, newValue);
                    nextValues[index] = str.formatTrimmed(str.formatStringArray(option.resultValue, newValue));
                    nextInputValues[index] = newValue;
                }
            } else {
                nextDisplays[index] = '';
                nextValues[index] = '';
                nextInputValues[index] = [];
            }

            setValues(nextValues);
            setInputValues(nextInputValues);
            setDisplays(nextDisplays);

            const validCount = nextValues.filter((x) => Boolean(x)).length;
            const optionCount = options.length;

            const setInput = optionCount - validCount == 0; // 모두 셋팅
            const unsetInput = optionCount - validCount == optionCount; // 모두 언셋팅

            if (setInput || unsetInput) {
                if (actions?.setProfileUpdates) {
                    const { _id, code, type } = filterType;
                    const newFilter = {
                        id: _id,
                        code,
                        type,
                        length: options.length,
                        value: JSON.stringify(nextValues),
                        inputValue: JSON.stringify(nextInputValues),
                        display: JSON.stringify(nextDisplays),
                        consent: consentValue,
                    };
                    actions.setProfileUpdates((prev) => addOrReplaceInArray(prev, _id, newFilter));
                } else if (actions?.onChange) {
                    actions.onChange(filterType, newValue ? true : false, nextValues, nextInputValues, nextDisplays);
                }
            }
        },
        [inputValues, values, displays, consentValue],
    );

    const getControlledValueAt = (index, option) => {
        const v = inputValues[index];
        if (option.selection > 1) {
            return Array.isArray(v) ? v : [];
        }
        return v || null;
    };

    return (
        <Grid container spacing={0} direction='row' justifyContent='flex-start' alignItems='center'>
            {options &&
                options.map((option, index) => (
                    <FilterAutoComplete
                        {...props}
                        key={`option ${index}`}
                        index={index}
                        selectionMax={option.selection}
                        filterOption={option}
                        consentInput={consentInput}
                        setConsentInput={setConsentInput}
                        setConsentValue={setConsentValue}
                        value={getControlledValueAt(index, option)}
                        onChangeValue={onChangeValue}
                    />
                ))}
        </Grid>
    );
}

export { FilterItem };
